import React from 'react'
import useStudentPreChecks from '../useStudentPreChecks'

export default function TestButton({action, retry, currentCheck, errorMessage}){

    const studentPreCheck = useStudentPreChecks({itemToCheck: currentCheck})

    const handleClick = () => {

        if(action === 'Pass'){
            studentPreCheck.finishCheck()
        }
        if(action === 'Fail'){
            try{
                throw(new Error(errorMessage))
            }catch(err){
                studentPreCheck.failedCheck(new Error("Test button failed", {
                    cause: err
                }))
            }
        }
        if(action === 'Retry'){
            retry()
        }
    }

    return <button onClick={handleClick}>{action}</button>

}